import { Button, DatePicker, Input, Select } from "antd";
import { TableProps } from "antd/es/table";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import DateIcon from "../../../assets/icons/DateIcon";
import DotIcon from "../../../assets/icons/DotIcon";
import EditIcon from "../../../assets/icons/EditIcon";
import FilterIcon from "../../../assets/icons/FilterIcon";
import SearchIcon from "../../../assets/icons/SearchIcon";
import SelectDownIcon from "../../../assets/icons/SelectDownIcon";
import SortIcon from "../../../assets/icons/SortIcon";
import ViewIcon from "../../../assets/icons/ViewIcon";
import CustomTable from "../../../components/ui/CustomTable";
import { dateFormat } from "../../../constants/constants";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { formatDate } from "../../../lib/time";
import { countParPageSerialNumber } from "../../../utils/number";
import { selectSearchOption, selectStringOption } from "../../../utils/utils";

export default function Customers() {
  const { page, limit, handlePagination, handleLimit } = useTable();

  const columns: TableProps<DataType>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Client ID",
      dataIndex: "clientId",
    },
    {
      title: "Company Name",
      dataIndex: "companyName",
    },
    {
      title: "Email Address",
      dataIndex: "email",
    },

    {
      title: "User",
      dataIndex: "userid",
      sorter: (a, b) => a.userid.localeCompare(b.userid),
      sortIcon: () => <SortIcon />,
    },
    {
      title: "Package",
      dataIndex: "pack",
      sorter: (a, b) => a.pack.localeCompare(b.pack),
      sortIcon: () => <SortIcon />,
      render: (text) => (
        <p className="flex items-center">
          <DotIcon />
          <span className="ml-[6px]"> {text}</span>
        </p>
      ),
    },
    {
      title: "Pkg Expire",
      dataIndex: "pkg",
      sorter: (a, b) => a.pkg.localeCompare(b.pkg),
      sortIcon: () => <SortIcon />,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (value: keyof typeof Status) => (
        <span className={Status[value]}>{value}</span>
      ),
    },
    {
      title: "Actions",
      dataIndex: "id",
      align: "center",
      render: (val) => (
        <div className="flex justify-center items-center gap-2">
          <Button
            className="action-button"
            size="small"
            icon={<EditIcon />}
            // onClick={() =>
            //   handleOpen({
            //     type: "UPDATE",
            //     data: val,
            //   })
            // }
          />

          <Link to={`/admin/customers/view/${val?.id}`}>
            <Button
              className="action-button"
              size="small"
              icon={<ViewIcon />}
            />
          </Link>
        </div>
      ),
    },
  ];

  return (
    <SidebarLayout title="Customers">
      <CustomTable
        loading={false}
        limit={limit}
        page={page}
        columns={columns}
        total={120} // Update total as per the data
        dataSource={data}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        filterSection={
          <>
            <Input
              suffix={<SearchIcon />}
              placeholder="Search by name, id"
              style={{ width: 220 }}
            />
            <Select
              allowClear
              showSearch
              placeholder="Filter"
              filterOption={selectSearchOption}
              // options={selectStringOption([
              //   "IT",
              //   "Design",
              //   "Development",
              //   "Mobile App",
              // ])}
              className="min-w-[130px]"
              suffixIcon={<FilterIcon />}
              rootClassName="icon-gray"
            />

            <Select
              allowClear
              showSearch
              placeholder="Status"
              filterOption={selectSearchOption}
              options={selectStringOption(["Active", "Inactive", "New"])}
              className="min-w-[90px]"
              suffixIcon={<SelectDownIcon />}
              rootClassName="icon-gray"
            />

            <DatePicker
              defaultValue={dayjs(formatDate(), dateFormat)}
              format={dateFormat}
              style={{ width: 135 }}
              suffixIcon={<DateIcon />}
            />

            <Select
              allowClear
              showSearch
              placeholder="digiGO"
              filterOption={selectSearchOption}
              // options={selectStringOption(["Active", "Inactive"])}
              className="min-w-[90px] "
              suffixIcon={<SelectDownIcon />}
              rootClassName="icon-gray"
            />
          </>
        }
      />
    </SidebarLayout>
  );
}

interface DataType {
  clientId: string;
  companyName: string;
  email: string;
  userid: string;
  pack: string;
  pkg: string;
  status: string;
  id: string;
}

const data: DataType[] = [
  {
    clientId: "000193",
    companyName: "Jacob Jones",
    email: "name@email.com",
    userid: "123",
    pack: "Package",
    pkg: "10 Jan, 2026",
    status: "New",
    id: "1",
  },
  {
    clientId: "000193",
    companyName: "Jacob Jones",
    email: "name@email.com",
    userid: "123",
    pack: "Package",
    pkg: "10 Jan, 2026",
    status: "Inactive",
    id: "2",
  },
  {
    clientId: "000193",
    companyName: "Jacob Jones",
    email: "name@email.com",
    userid: "123",
    pack: "Package",
    pkg: "10 Jan, 2026",
    status: "Active",
    id: "3",
  },
];

enum Status {
  Active = "status-success",
  Inactive = "status-info",
  New = "status-dark",
}
